import axios from 'axios'

// Configurar axios para localhost
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://localhost:7209/api/',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

const API_BASE_URL = '/TipoPlan'

const tipoPlanService = {
  // Obtener todos los tipos de plan activos
  async getAll() {
    try {
      const response = await api.get(API_BASE_URL)
      return response.data
    } catch (error) {
      console.error('Error loading tipo de plan:', error)
      throw error
    }
  },

  // Obtener tipo de plan por ID
  async getById(id) {
    try {
      const response = await api.get(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error loading tipo de plan by ID:', error)
      throw error
    }
  },

  // Crear nuevo tipo de plan
  async create(tipoPlanData) {
    try {
      const response = await api.post(API_BASE_URL, tipoPlanData)
      return response.data
    } catch (error) {
      console.error('Error creating tipo de plan:', error)
      throw error
    }
  },

  // Actualizar tipo de plan
  async update(id, tipoPlanData) {
    try {
      const response = await api.put(`${API_BASE_URL}/${id}`, tipoPlanData)
      return response.data
    } catch (error) {
      console.error('Error updating tipo de plan:', error)
      throw error
    }
  },

  // Eliminar tipo de plan
  async delete(id) {
    try {
      const response = await api.delete(`${API_BASE_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error('Error deleting tipo de plan:', error)
      throw error
    }
  },
}

export default tipoPlanService

